import * as components from './components/index.js'
import * as functions from './functions/index.js'
import * as methods from './methods/index.js'
import * as state from './state.js'

export default {
  components,
  functions,
  methods,
  state
}
